import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { Modal, Button } from "react-bootstrap";
import { purchaseList } from "../../Services/Operations/ProductAPI";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import "../../Styles/PurchaseReport.css";
import { useSelector } from "react-redux";

const PurchaseReport = () => {
  const [purchases, setPurchases] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
    const token = useSelector((state) => state.user.token);
    console.log("token : ", token);


         const [currentPage, setCurrentPage] = useState(1);
        const itemsPerPage = 10;
        
        const indexOfLast = currentPage * itemsPerPage;
        const indexOfFirst = indexOfLast - itemsPerPage;
        
        const currentItems = purchases.slice(indexOfFirst, indexOfLast);
    

  useEffect(() => {
    const fetchPurchaseList = async () => {
      try {
        const response = await purchaseList(token);
        setPurchases(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchPurchaseList();
  }, []);

  const handleViewDetails = (purchase) => {
    setSelectedPurchase(purchase);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPurchase(null);
  };


  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Purchase Report</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Purchase Report
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

       
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Doctor-all">
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Bill No.</th>
                        <th>Vendor Name</th>
                        <th>GST Number</th>
                        <th>Purchase Date</th>
                        <th>Grand Total</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((purchase) => (
                        <tr key={purchase.id}>
                          <td>{purchase.id}</td>
                          <td>{purchase.billNo}</td>
                          <td>{purchase.vendorName || "N/A"}</td>
                          <td>{purchase.vendorGstNumber || "N/A"}</td>
                          <td>
                            {new Date(
                              purchase.purchaseDate
                            ).toLocaleDateString()}
                          </td>
                          <td>₹{purchase.grandTotal}</td>
                          <td>
                            {purchase.status === 0 ? (
                              <span className="badge badge-warning">
                                Pending
                              </span>
                            ) : (
                              <span className="badge badge-success">
                                Completed
                              </span>
                            )}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={() => handleViewDetails(purchase)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                            
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                                  <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(purchases.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(purchases.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal for Purchase Details */}
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Purchase Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedPurchase && (
              <div>
                <p>
                  <strong>ID:</strong> {selectedPurchase.id}
                </p>
                <p>
                  <strong>Bill No.:</strong> {selectedPurchase.billNo}
                </p>
                <p>
                  <strong>Vendor Name:</strong>{" "}
                  {selectedPurchase.vendorName || "N/A"}
                </p>
                <p>
                  <strong>GST Number:</strong>{" "}
                  {selectedPurchase.vendorGstNumber || "N/A"}
                </p>
                <p>
                  <strong>Purchase Date:</strong>{" "}
                  {new Date(selectedPurchase.purchaseDate).toLocaleDateString()}
                </p>
                <p>
                  <strong>Grand Total:</strong> ₹{selectedPurchase.grandTotal}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {selectedPurchase.status === 0 ? "Pending" : "Completed"}
                </p>
                <p>
                  <strong>Sub Total:</strong> ₹
                  {selectedPurchase.subTotal || "N/A"}
                </p>
                <p>
                  <strong>Payable Amount:</strong> ₹
                  {selectedPurchase.payableAmount || "N/A"}
                </p>
                <p>
                  <strong>Due Amount:</strong> ₹
                  {selectedPurchase.dueAmount || "N/A"}
                </p>
                <p>
                  <strong>Payment Mode:</strong>{" "}
                  {selectedPurchase.paymentMode || "N/A"}
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PurchaseReport;
